import React from 'react';

const Image = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2273 2.06226H5.73825C3.47925 2.06226 2.0625 3.66276 2.0625 5.92776V12.0373C2.0625 14.3023 3.47325 15.9028 5.73825 15.9028H12.2235C14.4923 15.9028 15.9022 14.3023 15.9022 12.0373V5.92776C15.9052 3.66276 14.4945 2.06226 12.2273 2.06226Z"
        stroke="#A5A5A5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.02779 6.58872C8.02779 7.35372 7.40829 7.97322 6.64329 7.97322C5.87904 7.97322 5.25879 7.35372 5.25879 6.58872C5.25879 5.82372 5.87904 5.20422 6.64329 5.20422C7.40754 5.20497 8.02704 5.82447 8.02779 6.58872Z"
        stroke="#A5A5A5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9053 11.2132C15.213 10.5007 13.8818 9.0614 12.4343 9.0614C10.986 9.0614 10.1512 12.2362 8.7585 12.2362C7.36575 12.2362 6.1005 10.8007 4.9845 11.7209C3.8685 12.6404 2.8125 14.5207 2.8125 14.5207"
        stroke="#A5A5A5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Image;
